export enum CustomerDispatchTypes {
  LOGIN_CUSTOMER = 'LOGIN_CUSTOMER',
  LOGOUT_CUSTOMER = 'LOGOUT_CUSTOMER',
  REGISTER_CUSTOMER = 'REGISTER_CUSTOMER',
  ADD_PURCHASEITEM = 'ADD_PURCHASEITEM',
  UPDATE_STATUS_CUSTOMER = 'UPDATE_STATUS_CUSTOMER'
}
